import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import BlockedIpStatusBadge from './BlockedIpStatusBadge';
import { formatDate } from '../../../../utils/Utils';

const KIND_LABEL = {
  progressive: 'Bloqueio progressivo',
  rate_limit: 'Limite de requisições',
};

/**
 * Formata uma data 'Y-m-d H:i:s' usando formatDate() do projeto.
 * @param {string|null} dateStr
 * @returns {string}
 */
function fmtDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return '—';
  return formatDate(date);
}

/**
 * BlockedIpRow - Linha da tabela de IPs bloqueados (Admin Geral > Segurança)
 * @param {Object} props
 * @param {Object} props.entry
 * @param {Function} props.onUnblock
 */
function BlockedIpRow({ entry, onUnblock }) {
  const { ip, kind, endpoint, attempts, last_attempt, blocked_until, is_blocked } = entry;

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>{ip}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{KIND_LABEL[kind] || kind}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="text.secondary">{endpoint || '—'}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{attempts ?? 0}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{fmtDate(last_attempt)}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{fmtDate(blocked_until)}</Typography>
      </TableCell>
      <TableCell>
        <BlockedIpStatusBadge isBlocked={is_blocked} />
      </TableCell>
      <TableCell align="right">
        <Button
          size="small"
          variant="outlined"
          startIcon={<LockOpenOutlinedIcon fontSize="small" />}
          onClick={() => onUnblock(entry)}
        >
          Liberar
        </Button>
      </TableCell>
    </TableRow>
  );
}

export default BlockedIpRow;
